import React from "react";
import {
  Card,
  Toaster,
  Position,
  Button,
  Intent,
  Tag,
  Menu,
  MenuItem,
  Popover,
  Spinner
} from "@blueprintjs/core";
import RandomString from "randomstring";
import { storage } from "../../fire";
import { shuffle } from "lodash";


import {
  toast_deleteError,
  toast_deleteSuccess,
  toast_uploadError,
  toast_uploadInProgress,
  toast_uploadSuccess,
  toast_warningError
} from "./Sequences/Toast";
import DialogAddResource from "./Sequences/DialogAddResource";
import TableResources from "./Sequences/TableResources";
import CreatePanelSequencesTableSequences from "./Sequences/TableSequences";

import Auth from "../../services/Auth";
import Session from "../../services/Session";

class SequencesPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogIsOpen: false,
      isDeletingResource: false,
      // resource: {
      //   name: null,
      //   file: null,
      //   fileBlob: null,
      //   downloadURL: null,
      //   type: null
      // },
      submiting: false,
      resources: []
    };
  }

  handleOpenDialog = () => this.setState({ dialogIsOpen: true });
  handleCloseDialog = () => this.setState({
    dialogIsOpen: false,
    resources: []
  });

  handleChangeFileInput = e => {
    let files = []
    for (let i = 0; i < e.target.files.length; i++) {
      let newFile = e.target.files[i]
      let file = RandomString.generate(16);
      let name = newFile.name
      let blob = newFile

      let type

      if (newFile.type.includes('image')) {
        type = 'IMAGE'
      } else if (newFile.type.includes('video')) {
        type = 'VIDEO'
      } else {
        alert('File type not allowed')
      }

      files.push({ name: name, file: file, fileBlob: blob, type: type, downloadURL: null })

      if (i === e.target.files.length - 1) {
        this.setState({ resources: this.state.resources.concat(files) })
      }
    }
  };

  handleAddResource = () => {
    this.setState({ submiting: true });
    this.state.resources.forEach((resource) => {
      const { resources, onChangeSequencesResources, sessionId } = this.props;
      const uploadToastKey = this.toaster.show(toast_uploadInProgress(0));
      const storageRef = Session.addResource({
        sessionId,
        resource,
        onProgress: snapshot => {
          /**
           * Upload is in progress
           * --
           * Calculate purcentage of uploading
           * Update the upload toast with the new purcentage
           */
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          this.toaster.show(toast_uploadInProgress(progress), uploadToastKey);
        },
        onError: e => {
          /**
           * Upload has errored
           * --
           * Set the new state (no more submiting and resrouce obj is reseted)
           * Close the 'Télécharger une image' dialog
           * Dismiss the upload toast
           * Show an error toast
           */
          this.setState({
            submiting: false,
            resource: {
              name: null,
              file: null,
              fileBlob: null,
              downloadURL: null,
              type: null
            }
          });
          this.handleCloseDialog();
          this.toaster.dismiss(uploadToastKey);
          this.toaster.show(toast_uploadError());
          console.error("An error has been occured when uploading\n", e.message);
        },
        onComplete: () => {
          /**
           * Upload is complete
           * --
           * Give an id to the resource (usefull for resource removing)
           * Get the download URL of the uploaded file (async)
           * Push the resource to the list of resource (omit the fileBlob attribute)
           * Call prop handler 'onChangeResource' to update the list of resource of the parent component
           * Set the new state (update list of resource, no more submiting and resource obj is reseted)
           * Dismiss the upload toast
           * Show a success toast
           */
          storageRef
            .getDownloadURL()
            .then(url => {
              resource.downloadURL = url
            })
            .then(() => {
              resources.push({
                id: RandomString.generate(16),
                name: resource.name,
                file: resource.file,
                downloadURL: resource.downloadURL,
                type: resource.type
              });
              onChangeSequencesResources(resources);
              this.setState({
                submiting: false,
                resource: {
                  name: null,
                  file: null,
                  fileBlob: null,
                  downloadURL: null,
                  type: null
                }
              });
              this.handleCloseDialog();
              this.toaster.dismiss(uploadToastKey);
              this.toaster.show(toast_uploadSuccess());
            });
        }
      });
    })
  };

  handleDeleteResource = id => {
    let { resources } = this.props;
    const { onChangeSequencesResources, sessionId } = this.props;
    const storageRef = storage.ref(
      `sequences/${Auth.getUserId()}/${sessionId}/${resources.find(r => r.id === id).file
      }`
    );

    const deleteResource = () => {
      // Delete the element that has the given id using Array.filter
      resources = resources.filter(r => r.id !== id);
      this.removeSequencesWithResource(id);
      onChangeSequencesResources(resources);
    };

    this.setState({ isDeletingResource: true });
    storageRef
      .delete()
      .then(() => {
        this.toaster.show(toast_deleteSuccess());
        deleteResource();
        this.setState({ isDeletingResource: false });
      })
      .catch(e => {
        const { code } = e;

        this.setState({ isDeletingResource: false });
        switch (code) {
          case "storage/unknown":
            this.toaster.show(
              toast_deleteError("An error occurred...")
            );
            break;
          case "storage/object-not-found":
            this.toaster.show(
              toast_warningError(
                "File were not fown, but we still deleted resource.",
                10000
              )
            );
            deleteResource();
            break;
          case "storage/quota-exceeded":
            this.toaster.show(
              toast_deleteError("Allocated storage space is full.")
            );
            break;
          case "storage/unauthenticated":
            this.toaster.show(
              toast_deleteError("Thank you for authenticating !")
            );
            break;
          default:
            this.toaster.show(toast_deleteError(e.message));
            break;
        }
      });
  };

  handleEditResource = (value, name, id) => {
    let resources = this.props.resources
    resources[id].name = value

    this.props.onChangeSequencesResources(resources)
  }

  handleGenerateSequences = (shiftBeforeGenerate = false) => {
    let { protocol, sequences, resources, onChangeSequences } = this.props;
    const generateSequencesForProtocolMSAndMC = () =>
      resources.forEach(r =>
        sequences.push({ id: RandomString.generate(16), resources: [r] })
      );
    const generateSequencesForProtocolPC = () => {
      for (let i = 0; i < resources.length - 1; i++)
        for (let j = i + 1; j < resources.length; j++)
          sequences.push({
            id: RandomString.generate(16),
            resources: [resources[i], resources[j]]
          });
    };

    if (shiftBeforeGenerate) sequences = [];
    switch (protocol) {
      case "PC":
        if (resources.length <= 1)
          this.toaster.show(
            toast_warningError(
              "The protocol you chosed require at least 2 images to generate sequences."
            )
          );
        generateSequencesForProtocolPC();
        break;
      case "CM":
        if (resources.length <= 1)
          this.toaster.show(
            toast_warningError(
              "The protocol you chosed require at least 2 images."
            )
          );
        generateSequencesForProtocolPC();
        break;
      case "MS":
        generateSequencesForProtocolMSAndMC();
        break;
      case "MC":
        generateSequencesForProtocolMSAndMC();
        break;
      default:
        this.toaster.show(
          toast_warningError(
            "Unknow protocol, impossible to create sequence"
          )
        );
        return;
    }
    if (sequences.length === 0) return;
    onChangeSequences(sequences);
  };


  handleShuffleSequences = () =>
    this.props.onChangeSequences(shuffle(this.props.sequences));
  handleDeleteSequence = id => {
    let { sequences, onChangeSequences } = this.props;

    // Delete the element that has the given id using Array.filter
    sequences = sequences.filter(s => s.id !== id);
    onChangeSequences(sequences);
  };

  handleAddSequence = () => {
    const { sequences = [], onChangeSequences } = this.props;

    sequences.push({
      id: RandomString.generate(16),
      resources: []
    });
    onChangeSequences(sequences);
  };

  handleAddChannelToSequence = (sequenceId, channel) => {
    const { sequences = [], onChangeSequences } = this.props;
    const indexOfSequence = sequences.findIndex(s => s.id === sequenceId);
    let targetedSequence = null;

    if (indexOfSequence == null)
      return console.warning(
        "Cannot find by id a sequence in the list of sequence"
      );
    targetedSequence = sequences[indexOfSequence];
    if (!targetedSequence.resources) targetedSequence.resources = [];
    targetedSequence.resources.push({ ...channel });

    // targetedSequence is a reference
    // we don't need to `sequences[indexOfSequence] = targetedSequence`
    onChangeSequences(sequences);
  };

  handleChangeResourcesOrder = (currentIndex, newIndex) => {
    let { onChangeSequencesResources, resources = [] } = this.props;

    resources.splice(newIndex, 0, resources.splice(currentIndex, 1)[0]);
    onChangeSequencesResources(resources)
  };


  handleRemoveChannelFromSequence = (sequenceId, ifOfChannelToRemove) => {
    const { sequences = [], onChangeSequences } = this.props;
    const indexOfSequence = sequences.findIndex(s => s.id === sequenceId);
    let targetedSequence = null;

    if (indexOfSequence == null)
      return console.warning(
        "Cannot find by id a sequence in the list of sequence"
      );
    targetedSequence = sequences[indexOfSequence];
    if (!targetedSequence.resources)
      return console.warning(
        "Trying to remove a channel but no channels are set"
      );
    targetedSequence.resources = targetedSequence.resources.filter(
      channel => channel.id !== ifOfChannelToRemove
    );
    // targetedSequence is a reference
    // we don't need to `sequences[indexOfSequence] = targetedSequence`
    onChangeSequences(sequences);
  };

  removeSequencesWithResource = resourceId => {
    let { sequences, onChangeSequences } = this.props;

    // Only retrieve sequences that don't have the given resource in their list of resource
    sequences = sequences.filter(
      s => s.resources.find(r => r.id === resourceId) == null
    );
    onChangeSequences(sequences);
  };

  render() {
    const {
      resources,
      sequences,
      instances = [],
      protocol,
      mcCriterias = []
    } = this.props;
    const {
      dialogIsOpen,
      submiting,
      isDeletingResource
    } = this.state;

    switch (protocol) {
      case "MC":
        return (
          <div>
            <div className="text-right">
              <Button
                className="text-right margin-bottom-medium"
                text="Add sequences"
                icon="add"
                disabled={instances.length !== 0}
                onClick={this.handleAddSequence}
                intent={Intent.PRIMARY}
              />
            </div>
            <CreatePanelSequencesTableSequencesForMultichannel
              mcCriterias={mcCriterias}
              instances={instances}
              sequences={sequences}
              resources={resources}
              onDeleteSequence={this.handleDeleteSequence}
              onAddChannelToSequence={this.handleAddChannelToSequence}
              onRemoveChannelFromSequence={this.handleRemoveChannelFromSequence}
            />
          </div>
        );
      default:
        return (
          <Card>
            <Toaster
              position={Position.TOP_RIGHT}
              autoFocus={false}
              ref={toaster => (this.toaster = toaster)}
            />
            <DialogAddResource
              resources={this.state.resources}
              dialogIsOpen={dialogIsOpen}
              submiting={submiting}
              // onChangeInput={this.handleChangeInput}
              onChangeFileInput={this.handleChangeFileInput}
              onCloseDialog={this.handleCloseDialog}
              onAddResource={this.handleAddResource}
            />
            {this.state.isDeletingResource ?
              <div style={{ marginTop: "20px" }}>
                <Spinner size={500} />
              </div>
              :
              <TableResources
                instances={instances}
                resources={resources}
                sequences={sequences}
                handleChangeResourcesOrder={this.handleChangeResourcesOrder}
                onDeleteResource={this.handleDeleteResource}
                deleting={isDeletingResource}
                onOpenDialog={this.handleOpenDialog}
                attributes={this.props.attributes}
                handleEditResource={this.handleEditResource}
                handleChangeAttribute={this.props.handleChangeAttribute}
                handleChangeAttributeUnitValue={this.props.handleChangeAttributeUnitValue}
                handleDeleteAttribute={this.props.handleDeleteAttribute}
              />
            }
            {resources.length > 0 && (
              <CreatePanelSequencesTableSequences
                instances={instances}
                sequences={sequences}
                resources={resources}
                onDeleteSequence={this.handleDeleteSequence}
                onGenerateSequences={this.handleGenerateSequences}
                onShuffleSequences={this.handleShuffleSequences}
              />
            )}
          </Card>
        );
    }
  }
}

class CreatePanelSequencesTableSequencesForMultichannel extends React.Component {
  render() {
    const {
      sequences = [],
      instances = [],
      mcCriterias = [],
      onAddChannelToSequence,
      onRemoveChannelFromSequence,
      onDeleteSequence
    } = this.props;

    return (
      <div>
        <Card>
          <table className="bp3-html-table full-width">
            <thead>
              <tr>
                <th>#</th>
                <th>Channels</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sequences.map((s, index) => (
                <tr key={index}>
                  <td>Sequence {index + 1}</td>

                  <td>
                    {instances.length === 0 && (
                      <Popover
                        disabled={instances.length !== 0}
                        content={
                          <AddChannelToSequenceMenu
                            criterias={mcCriterias}
                            sequence={s}
                            channels={s.resources}
                            onAddChannelToSequence={onAddChannelToSequence}
                          />
                        }
                      >
                        <Tag
                          large={false}
                          interactive={instances.length === 0}
                          round={true}
                          intent={Intent.SUCCESS}
                        >
                          Add Channel
                        </Tag>
                      </Popover>
                    )}
                    {s.resources &&
                      s.resources.map(channel => {
                        return (
                          <Tag
                            className="tiny-hoz-margin"
                            large={true}
                            key={channel.id}
                            round={true}
                            onRemove={
                              instances.length === 0
                                ? () =>
                                  onRemoveChannelFromSequence(s.id, channel.id)
                                : null
                            }
                          >
                            {channel.name}
                          </Tag>)
                      }
                      )}
                  </td>

                  <td style={{ textAlign: "right" }}>
                    <Button
                      icon="trash"
                      minimal={true}
                      onClick={() => onDeleteSequence(s.id)}
                      disabled={instances.length !== 0}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    );
  }
}

class AddChannelToSequenceMenu extends React.Component {
  render() {
    /**
     * this.props
     *  - Liste des channels de la séquences
     *  - Liste des mcChannels de la session (à remplacer par criteria)
     */
    const {
      sequence,
      criterias = [],
      onAddChannelToSequence,
      channels: sequenceChannels = []
    } = this.props;

    return (
      <Menu key="menu">
        {criterias.map(c => {
          if (!c.isFixed) {
            return (
              <MenuItem
                key={c.id}
                disabled={
                  sequenceChannels.find(channel => channel.id === c.id) == null
                    ? false
                    : true
                } /** Find if c.id is in Liste des channels de la séquences */
                text={c.name}
                onClick={() => onAddChannelToSequence(sequence.id, c)}
              />
            )
          } else {
            return <></>
          }
        }
        )}
      </Menu>
    );
  }
}

export default SequencesPanel;
